module.exports = __webpack_public_path__ + "static/img/empty.337b633.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/empty.png
// module id = fakP
// module chunks = 117